import React from 'react';
import { bool, object, func } from 'prop-types';
import { Drawer } from '../../../../components/common';
import { DrawerTitle } from './components/DrawerTitle';
import AuditOrderContainer from './components/AuditOrderContainer';
import { useAuditState } from './hooks/useAuditState';

const AuditOrderDrawer = ({ visible, selectedOrder, userInfo, onClose, refetch }) => {
    const {
        isBipickingGroup,
        orderId,
    } = useAuditState(selectedOrder);

    return (
        <Drawer
            minWidth='80%'
            className='audit-monitor'
            title={<DrawerTitle isBipickingGroup={isBipickingGroup} orderId={orderId} />}
            closable
            visible={visible}
            onClose={onClose}
        >
            {(visible && selectedOrder) && <AuditOrderContainer
                refetch={refetch}
                userInfo={userInfo}
                onClose={onClose}
                selectedOrder={selectedOrder}
            />}
        </Drawer>
    );
};

AuditOrderDrawer.propTypes = {
    visible: bool.isRequired,
    selectedOrder: object,
    userInfo: object,
    onClose: func.isRequired,
    refetch: func
};

export default AuditOrderDrawer;